import SelectFieldBase from '../base/SelectField';
import createField from './createField';

const SelectField = createField(SelectFieldBase);

export default SelectField;
